<template>
    <cms-block v-bind="$props" @block-selected="selectBlock" container-class="card" no-padding :class="{'has-image': block.image.isVisible()}"
        :block-component="CmsLink" :block-component-params="{link: currentLink}" :style="cssVar">
        <cms-component-image comp-id="image" :component="block.image" v-bind="componentProps"/>
        <b-card-body>
            <cms-component-glyph comp-id="glyph" :component="block.glyph" v-bind="componentProps"/>
            <cms-component-text comp-id="title" :component="block.title" placeholder="Title|Titre" v-bind="componentProps"/>
            <cms-component-text comp-id="subtitle" :component="block.subtitle" placeholder="Subtitle|Sous-titre" v-bind="componentProps"/>
            <cms-component-text comp-id="description" :component="block.description" placeholder="Description" v-bind="componentProps"/>
        </b-card-body>
        <b-card-footer v-if="block.altButton.isVisible() || block.mainButton.isVisible()" class="actions w-100">
            <cms-component-button comp-id="altButton" :component="block.altButton" placeholder="Alt Button|2e bouton" v-bind="componentProps"/>
            <cms-component-button comp-id="mainButton" :component="block.mainButton" placeholder="Button|Bouton" v-bind="componentProps"/>
        </b-card-footer>
    </cms-block>
</template>

<script>
import CmsLink from "@/components/cms/cms-link.vue";
import CmsBlock from "@/components/editor/rendering/blocks/cms-block.vue";
import CmsComponentButton from "@/components/editor/rendering/components/cms-component-button.vue";
import CmsComponentGlyph from "@/components/editor/rendering/components/cms-component-glyph.vue";
import CmsComponentImage from "@/components/editor/rendering/components/cms-component-image.vue";
import CmsComponentText from "@/components/editor/rendering/components/cms-component-text.vue";

// cms-block-card #hot-reload-debug
export default {
    name: `cms-block-card`,
    components: {CmsComponentGlyph, CmsLink, CmsComponentImage, CmsComponentButton, CmsComponentText, CmsBlock},
    extends: CmsBlock,
    data() {
        return {
            CmsLink
        }
    },
    computed: {
        currentLink() {
            let link;
            if (this.block.link.useBinding && this.boundItem && this.block.link.linkField) {
                link = this.boundItem.getField(this.block.link.linkField);
            }
            if (!link) {
                link = this.block.link.link;
            }
            return link;
        },
        cssVar() {
            return {
                "--img-span": `${this.block.mediaProxy.span}fr`,
                "--content-span": `${12 - this.block.mediaProxy.span}fr`
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.cms-block-card {
    display: grid;

    .card-body {
        padding: var(--block-padding-top) var(--block-padding-right) var(--block-padding-bottom) var(--block-padding-left);
        display: flex;
        flex-direction: column;
        justify-content: center;
        grid-area: card-body;
    }

    .card-footer {
        display: flex;
        align-items: center;
        grid-area: card-footer;

        .cms-component-button {
            vertical-align: middle;
            margin-top: 0;

            & + .cms-component-button {
                margin-left: var(--block-x-spacing);
            }
        }
    }

    &.layout-reversed {
        ::v-deep .cms-container {
            display: flex;
            flex-direction: column;
        }

        .cms-component-image {
            order: 3;
        }

        .card-footer {
            order: 2;
        }
    }

    &.layout-row-left,
    &.layout-row-right {
        &.has-image {
            ::v-deep .cms-container {
                display: grid !important;
                grid-template-columns: var(--img-span) var(--content-span);
                grid-template-areas:
                "image card-body"
                "card-footer card-footer";

                //> .cms-component-image {
                //    grid-column: span var(--img-span) !important;
                //}
                //
                //> .card-body {
                //    grid-column: span calc(12 - var(--img-span)) !important;
                //}
            }
        }

        .card-body {
            display: grid;
            grid-template-areas:
                "glyph title"
                "empty subtitle"
                "empty description";

            .cms-component-glyph {
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
    }

    &.layout-row-right {
        &.has-image {
            ::v-deep .cms-container {
                grid-template-columns: var(--content-span) var(--img-span);
                grid-template-areas:
                "card-body image"
                "card-footer card-footer" !important;
                //grid-template-columns: 3fr 1fr;
            }
        }

        .card-body {
            grid-template-areas:
                "title glyph"
                "subtitle subtitle"
                "description description";
        }
    }
}
</style>
